import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-tab',
  templateUrl: './tab.component.html',
  styleUrls: ['./tab.component.scss']
})
export class TabComponent implements OnChanges {
  @Input() properties!: { header: string, name?: string, active?: boolean }[];
  @Input() templates?: any[];
  @Input() class?: string;
  @Input() name: string = "";
  @Output() tabClicked = new EventEmitter<string>();

  ngOnChanges(changes: SimpleChanges) {
    if (changes['properties']) {
    }
  }

  onClick(header: string) {
    this.properties.forEach(property => {
      if (property.header == header) {
        property.active = true
      } else {
        property.active = false
      }
    });
    this.tabClicked.emit(header);
  }

}
